import { FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import { FieldSkeleton } from '../FieldSkeleton/FieldSkeleton';

import { FloorSelect, FloorSelectItem, FloorSelectProps } from './FloorSelect';

export interface FormFloorSelectProps
  extends Omit<FloorSelectProps, 'floor' | 'onChange'> {
  name: string;
  onChange?: (value: FloorSelectItem | undefined) => void;
  loading?: boolean;
}

export const FormFloorSelect: FC<FormFloorSelectProps> = ({
  name,
  required,
  onChange,
  loading,
  ...rest
}) => {
  const validate = useCallback(
    (value: FloorSelectItem | undefined) => {
      if (required && value === undefined) return 'Заполните поле';

      return '';
    },
    [required],
  );

  const { input, meta } = useField(name, { type: 'string', validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (value: FloorSelectItem | undefined) => {
      input.onChange(value);
      onChange?.(value);
    },
    [input, onChange],
  );

  return loading ? (
    <FieldSkeleton />
  ) : (
    <FloorSelect
      floor={input.value}
      {...rest}
      required={required}
      error={!!error}
      helperText={error}
      onChange={handleChange}
    />
  );
};
